import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=583375d1&scoped=true&"
import script from "./InvoiceTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTable.vue?vue&type=style&index=0&id=583375d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583375d1",
  null
  
)

export default component.exports